export enum ProposalItemPriceExplanationStatus {
    SUCCESS,
    ERROR
}
